import React from "react";
import "./home.css";

function Home() {
    return (
      <section className="parallax-container">
        <div className="parallax-overlay">
        {/* Contingut principal de la pàgina */}
        <div className="content">
          {/* Hero Section */}
          <section className="hero">
            <h1 className="hero-title">Qui som?</h1>
            <p className="hero-subtitle">
              FRIVENTCA, S.A., fou fundada a l'any 1978 com una empresa dedicada a
              la instal·lació d'aire condicionat, ventilació, calefacció i refrigeració.
            </p>
          </section>
  
          {/* About Section */}
          <section className="about">
            <div className="about-content">
              <p>
                Des dels nostres inicis, la política de la nostra companyia ha estat
                basada en oferir la millor qualitat del producte i en prestar un
                servei àgil i eficaç.
              </p>
              <p>
                Actualment estem treballant amb noves tecnologies més eficients i
                respectuoses amb el medi ambient.
              </p>
            </div>
            <img
              src="/images/qui-som-1.jpg"
              alt="Eficiència Energètica"
              className="about-image"
            />
          </section>
  
          {/* Call to Action */}
          <section className="call-to-action">
            <h2>En vols saber més?</h2>
            <button className="btn btn-primary" onClick={() => alert("Contacta amb nosaltres!")}>
              Contacta'ns
            </button>
          </section>
        </div>
        </div>
      </section>
    );
  }
  
  export default Home;
  
  

